(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-nikaneko"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const DOTS_VERSION = 'collection-links-2-sync-v3';

    function initCollectionLinkDots(root) {
      if (!root) return;

      if (root.dataset.collectionDotsVersion === DOTS_VERSION) return;
      root.dataset.collectionDotsVersion = DOTS_VERSION;

      const component = root.querySelector('collection-links-component');
      const dots = Array.from(root.querySelectorAll('.collection-links__dot'));
      const imageArea =
        root.querySelector('.collection-links__image-area') ||
        root.querySelector('.collection-links__images');

      const slideshow =
        root.querySelector('[ref="slideshow"]') ||
        root.querySelector('slideshow-component') ||
        root.querySelector('.collection-links__images') ||
        imageArea;

      const linkItems = Array.from(root.querySelectorAll('.collection-links__container > *'));

      if (!component || !dots.length || !imageArea) return;

      function getSlides() {
        let slides = Array.from(
          imageArea.querySelectorAll(
            'slideshow-slide, [data-slide], .slideshow__slide, .slideshow-slide'
          )
        );

        if (!slides.length && slideshow) {
          slides = Array.from(
            slideshow.querySelectorAll(
              'slideshow-slide, [data-slide], .slideshow__slide, .slideshow-slide'
            )
          );
        }

        return slides;
      }

      function setActiveDot(index) {
        if (index < 0 || index >= dots.length) return;

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;

          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      function getIndexFromSlideshowAttribute() {
        if (!slideshow) return null;

        const possibleAttributes = [
          'current-slide',
          'current-index',
          'selected-index',
          'active-slide',
          'data-current-slide',
          'data-current-index',
          'data-selected-index',
          'data-active-slide',
        ];

        for (const attribute of possibleAttributes) {
          const value = slideshow.getAttribute(attribute);

          if (value !== null && value !== '') {
            const number = Number(value);

            if (!Number.isNaN(number)) return number;
          }
        }

        const possibleProperties = [
          'currentSlide',
          'currentSlideIndex',
          'selectedIndex',
          'activeIndex',
          'slideIndex',
        ];

        for (const property of possibleProperties) {
          const value = slideshow[property];

          if (typeof value === 'number' && !Number.isNaN(value)) {
            return value;
          }
        }

        return null;
      }

      function getIndexFromActiveSlide() {
        const slides = getSlides();

        if (!slides.length) return null;

        const activeSelectors = [
          '[aria-current="true"]',
          '[aria-hidden="false"]',
          '[active]',
          '[selected]',
          '.is-active',
          '.active',
          '.current',
          '.is-selected',
        ];

        for (const selector of activeSelectors) {
          const activeElement = imageArea.querySelector(selector);

          if (activeElement) {
            const slide = activeElement.matches(
              'slideshow-slide, [data-slide], .slideshow__slide, .slideshow-slide'
            )
              ? activeElement
              : activeElement.closest(
                  'slideshow-slide, [data-slide], .slideshow__slide, .slideshow-slide'
                );

            const index = slides.indexOf(slide);

            if (index !== -1) return index;
          }
        }

        return null;
      }

      function getIndexFromVisibleSlide() {
        const slides = getSlides();

        if (!slides.length) return null;

        const areaRect = imageArea.getBoundingClientRect();
        const areaCenter = areaRect.left + areaRect.width / 2;

        let bestIndex = 0;
        let bestDistance = Infinity;

        slides.forEach((slide, index) => {
          const style = window.getComputedStyle(slide);

          if (
            style.display === 'none' ||
            style.visibility === 'hidden' ||
            Number(style.opacity) === 0
          ) {
            return;
          }

          const rect = slide.getBoundingClientRect();

          if (!rect.width || !rect.height) return;

          const slideCenter = rect.left + rect.width / 2;
          const distance = Math.abs(slideCenter - areaCenter);

          if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = index;
          }
        });

        return bestIndex;
      }

      function getCurrentIndex() {
        const fromAttribute = getIndexFromSlideshowAttribute();

        if (fromAttribute !== null && fromAttribute >= 0 && fromAttribute < dots.length) {
          return fromAttribute;
        }

        const fromActiveSlide = getIndexFromActiveSlide();

        if (fromActiveSlide !== null && fromActiveSlide >= 0 && fromActiveSlide < dots.length) {
          return fromActiveSlide;
        }

        const fromVisibleSlide = getIndexFromVisibleSlide();

        if (fromVisibleSlide !== null && fromVisibleSlide >= 0 && fromVisibleSlide < dots.length) {
          return fromVisibleSlide;
        }

        return 0;
      }

      function syncDots() {
        window.requestAnimationFrame(function () {
          setActiveDot(getCurrentIndex());
        });
      }

      function triggerCollectionHover(index) {
        if (!linkItems[index]) return;

        const targets = [
          linkItems[index],
          ...Array.from(
            linkItems[index].querySelectorAll('a, button, [role="button"], [tabindex]')
          ),
        ];

        targets.forEach((target) => {
          ['pointerenter', 'mouseenter', 'mouseover', 'focusin'].forEach((eventName) => {
            target.dispatchEvent(
              new Event(eventName, {
                bubbles: true,
                cancelable: true,
              })
            );
          });
        });
      }

      function trySelectSlideshow(index) {
        if (!slideshow) return;

        const methods = [
          'select',
          'goToSlide',
          'setSlide',
          'selectSlide',
          'showSlide',
        ];

        for (const method of methods) {
          if (typeof slideshow[method] === 'function') {
            try {
              slideshow[method](index);
              return;
            } catch (error) {
              // Try next method.
            }
          }
        }

        const slides = getSlides();

        if (slides[index]) {
          slides[index].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest',
          });
        }
      }

      function goToSlide(index) {
        setActiveDot(index);
        triggerCollectionHover(index);
        trySelectSlideshow(index);

        window.setTimeout(syncDots, 80);
        window.setTimeout(syncDots, 250);
        window.setTimeout(syncDots, 500);
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          goToSlide(index);
        });
      });

      linkItems.forEach((item, index) => {
        ['pointerenter', 'mouseenter', 'mouseover', 'focusin'].forEach((eventName) => {
          item.addEventListener(eventName, function () {
            setActiveDot(index);
            window.setTimeout(syncDots, 120);
            window.setTimeout(syncDots, 300);
          });
        });
      });

      [
        'click',
        'pointerup',
        'touchend',
        'scroll',
        'transitionend',
        'animationend',
        'change',
        'slideshow:change',
        'slideshow:changed',
        'slideshow:select',
        'slideshow:slide-changed',
      ].forEach((eventName) => {
        imageArea.addEventListener(eventName, function () {
          window.setTimeout(syncDots, 80);
          window.setTimeout(syncDots, 250);
        });

        if (slideshow && slideshow !== imageArea) {
          slideshow.addEventListener(eventName, function () {
            window.setTimeout(syncDots, 80);
            window.setTimeout(syncDots, 250);
          });
        }
      });

      const observerTarget = slideshow || imageArea;

      const observer = new MutationObserver(function () {
        syncDots();
      });

      observer.observe(observerTarget, {
        subtree: true,
        attributes: true,
        attributeFilter: [
          'class',
          'style',
          'hidden',
          'active',
          'selected',
          'aria-current',
          'aria-hidden',
          'current-slide',
          'current-index',
          'selected-index',
          'active-slide',
          'data-current-slide',
          'data-current-index',
          'data-selected-index',
          'data-active-slide',
        ],
      });

      syncDots();

      window.setTimeout(syncDots, 300);
      window.setTimeout(syncDots, 800);
    }

    function initAllCollectionLinkDots() {
      document
        .querySelectorAll('[data-collection-links-section-2]')
        .forEach(initCollectionLinkDots);
    }

    initAllCollectionLinkDots();

    document.addEventListener('shopify:section:load', function (event) {
      const root = event.target.querySelector('[data-collection-links-section-2]');

      if (root) {
        initCollectionLinkDots(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
